document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  const hamburger = document.getElementById('rmo-hamburger');
  const mobileNav = document.getElementById('rmo-mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      const open = mobileNav.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', open);
    });
  }

  // Close mobile nav on link click
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        hamburger && hamburger.setAttribute('aria-expanded', false);
      });
    });
  }

});
